<template>
  <sfs-base-list-filter
    title="Filter Quotes"
    :table-name="tableName"
    :applied-filters="appliedFilters"
    :displayed-columns="displayedColumns"
    :available-columns="availableColumns"
    @filters-applied="onFiltersApplied"
    @filters-reset="onDefaultPresetApplied"
    @filter-cleared="onFilterCleared"
    :advanced-filter="false"
    :popover-filter="true"
  >
    <template #quick-filters>
      <b-form-group
        label="Search fields for Data"
        label-for="quick-filter-text"
        label-sr-only
      >
        <b-input-group>
          <b-form-input
            id="quick-filter-text"
            v-model="filters.text"
            type="text"
            placeholder="Filter by Number, Location or Client"
            @keydown.enter.native="applyFilters"
          />
          <template #append>
            <b-button
              id="quick-filter-apply-button"
              @click="applyFilters"
              variant="primary"
            >
              <i class="fa fa-search" />
            </b-button>
          </template>
        </b-input-group>
      </b-form-group>
    </template>

    <template #popover-filters>
      <b-row>
        <b-col>
          <b-form-group
            label="Status"
            label-for="advanced-filter-status"
            label-cols-lg="5"
            content-cols-lg="7"
          >
            <v-select
              id="quick-filter-status"
              v-model="filters.status"
              :options="statusOptions"
              placeholder="All"
              :reduce="(status) => status.value"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Client"
            label-for="advanced-filter-client_id"
            label-cols-lg="5"
            content-cols-lg="7"
          >
            <client-select
              id="advanced-filter-client_id"
              placeholder="All"
              :value="client"
              @input="onClientChange"
              :persist-state="true"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            label="Location"
            label-for="advanced-filter-location"
            label-cols-lg="5"
            content-cols-lg="7"
          >
            <location-select
              id="advanced-filter-location"
              placeholder="All"
              :value="location"
              @input="onLocationChange"
              :persist-state="true"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </template>
  </sfs-base-list-filter>
</template>
<script>
import listFilterMixin from '@/mixins/listFilterMixin';
import ClientSelect from '@/components/admin/clients/Select.vue';
import LocationSelect from '@/components/admin/locations/Select.vue';

import { QUOTE_TABLE_COLUMN_OPTIONS, QUOTE_TABLE_DEFAULT_COLUMNS, QUOTE_TABLE_NAME, QUOTES_FORM_LABELS } from '@/constants/quotes';

export default {
  name: 'QuotesListFilter',
  mixins: [listFilterMixin],
  components: {
    ClientSelect,
    LocationSelect,
  },
  data() {
    return {
      availableColumns: QUOTE_TABLE_COLUMN_OPTIONS,
      fieldLabels: QUOTES_FORM_LABELS,
      tableName: QUOTE_TABLE_NAME,
      statusOptions: [],
    };
  },
  mounted() {
    this.getStatusOptions();
    this.loadInitialFilters();
  },
  methods: {
    onDefaultPresetApplied() {
      this.filters = {};
      this.displayedColumns = QUOTE_TABLE_DEFAULT_COLUMNS;
      this.applyFilters();
    },
    onClientChange(client) {
      this.filters.client_id = client ? client.id.toString() : '';
      this.client = client;
    },
    onLocationChange(location) {
      this.filters.location_id = location ? location.id.toString() : '';
      this.location = location;
    },
    loadInitialFilters() {
      const loadClient = new Promise((resolve) => {
        if (this.initialFilters.client_id) {
          this.$clientsAPI.get(this.initialFilters.client_id).then((client) => {
            resolve(client);
          });
        } else {
          resolve(null);
        }
      });

      const loadLocation = new Promise((resolve) => {
        if (this.initialFilters.location_id) {
          this.$locationsAPI.get(this.initialFilters.location_id).then((location) => {
            resolve(location);
          });
        } else {
          resolve(null);
        }
      });

      // The order of the resolved promises is preserved so we are able to use
      // indexes to fetch the data.
      Promise.all([loadClient, loadLocation]).then((values) => {
        this.client = values[0];
        this.location = values[1];
        this.applyFilters();
      });
    },
    getStatusOptions() {
      this.$quotesAPI.getStatusOptions().then((response) => {
        const options = response.data.status_options.map((option) => {
          return { label: option[0], value: option[1] };
        });
        this.statusOptions = [...options];
      });
    },
  },
};
</script>
